import type { TFunction } from "src/design-system/core";
import { ChannelSourceEnum } from "src/types/channel";

const CHANNEL_SOURCE_TRANSLATION_KEY = "enums.channel-source";

const SPONSORED_AD_DISABLED_CHANNEL_LIST = [ChannelSourceEnum.JustEat, ChannelSourceEnum.Glovo];
const COMBO_DISABLE_CHANNEL_LIST = [ChannelSourceEnum.JustEat, ChannelSourceEnum.Glovo];
const SPECIAL_DISABLE_CHANNEL_LIST = [ChannelSourceEnum.JustEat];

function isDisabledByServiceListAndReferenceArray(
    activatedServiceList: ChannelSourceEnum[],
    referenceArray: ChannelSourceEnum[]
): boolean {
    return activatedServiceList.every((service) => referenceArray.includes(service));
}

export function isComboDisabled(activatedServiceList: ChannelSourceEnum[]): boolean {
    return isDisabledByServiceListAndReferenceArray(
        activatedServiceList,
        COMBO_DISABLE_CHANNEL_LIST
    );
}

export function isSponsoredAdDisabled(activatedServiceList: ChannelSourceEnum[]): boolean {
    return isDisabledByServiceListAndReferenceArray(
        activatedServiceList,
        SPONSORED_AD_DISABLED_CHANNEL_LIST
    );
}

export function isSpecialOfferDisabled(activatedServiceList: ChannelSourceEnum[]): boolean {
    return isDisabledByServiceListAndReferenceArray(
        activatedServiceList,
        SPECIAL_DISABLE_CHANNEL_LIST
    );
}

export function sponsoredAdChannelDisabledList(
    activatedServiceList: ChannelSourceEnum[],
    translateCommon: TFunction
): string {
    return activatedServiceList
        .filter((service) => SPONSORED_AD_DISABLED_CHANNEL_LIST.includes(service))
        .map((e) => translateCommon(`${CHANNEL_SOURCE_TRANSLATION_KEY}.${e}`))
        .join(` ${translateCommon("word-link.and")} `);
}
